import React from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import { ModalBody, ModalTitle, ButtonDiv } from '../css';

import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';

const RevertAlertModal = (props) => {
  const { secondaryAction, primaryAction, fieldLabel } = props;

  // eslint-disable-next-line react/no-unstable-nested-components
  const Message = () => {
    if (fieldLabel) {
      const message = t('editLockedfieldWarningCustomMsg').split('[fieldLabel]');
      return (
        <>
          <p>
            {message[0]}
            {' '}
            <b>{fieldLabel}</b>
            {' '}
            {message[1]}
          </p>
          <p>{t('editLockedfieldWarningCustomMsgLine2')}</p>
        </>
      );
    }

    return (
      <>
        <p>{t('editLockedfieldWarningMsg')}</p>
        <p>{t('editLockedfieldWarningMsgLine2')}</p>
      </>
    );
  };

  return (
    <ModalBody>

      <ModalTitle>{t('Revert')}</ModalTitle>

      <Message />

      <ButtonDiv className="row no-gutters">

        <div className="col-sm-12 col-md">
          <PrimaryButton
            name="cancelButton"
            label={t('ReturnToShipment')}
            onClick={primaryAction}
          />
        </div>

        <div className="col-sm-12 col-md">
          <SecondaryButton
            name="createNewQuote"
            label={t('CreateaNewQuote')}
            onClick={secondaryAction}
          />
        </div>

      </ButtonDiv>

    </ModalBody>
  );
};

RevertAlertModal.propTypes = {
  primaryAction: PropTypes.func,
  secondaryAction: PropTypes.func,
  fieldLabel: PropTypes.string,
};

export default RevertAlertModal;
